<template>
  <client-only>
    <v-layout column my-3>
      <ArticleHighlight :class="'round-corners mb-2'" :highlight="customHighlight" />
      <v-flex xs12 sm6 mb-2 v-for="(question, index) in questions" :key="index">
        <QuestionItem :item="question" />
      </v-flex>
    </v-layout>
  </client-only>
</template>

<script>
import ArticleHighlight from '@/components/Articles/ArticleHighlight'
import QuestionItem from '@/components/Article/QuestionItem'

export default {
  components: {
    ArticleHighlight,
    QuestionItem
  },
  props: {
    questions: {
      type: Array,
      required: true
    },
    customHighlight: {
      type: String,
      required: true
    }
  }
}
</script>
